import React, { useState, useEffect, useContext } from 'react';
import MaterialTable from 'material-table';
import '../Styles/Tables.scss';
import Button from '@material-ui/core/Button';
import useFetch from 'CustomHooks/useFetch';
import { GlobalContext } from '../Contexts/GlobalContext';
import useGuiTranslations from './MultiLanguage/useGuiTranslations';
import { capitalizeFirstLetter } from '../Util/StringFunctions';


function Tables() {
  const [getTablesHookResponse, getTablesHook] = useFetch();
  const [addTableHookResponse, addTableHook] = useFetch();
  const [deleteTableResponse, deleteTableHook] = useFetch();
  const [editTableResponse, editTableHook] = useFetch();
  const [getQRCodeResponse, getQRCodeHook] = useFetch();
  const [qrCodeBase64, setQRCodeBase64] = useState();
  const [selectedTableURL, setSelectedTableURL] = useState('');
  const [selectedTableName, setSelectedTableName] = useState('-1');
  const [getCustomerSettingsHookResponse, getCustomerSettingsHook] = useFetch();
  const [customerLogoURL, setCustomerLogoURL] = useState();
  const [translateGui] = useGuiTranslations();
  const globalContext = useContext(GlobalContext);
  const [tables, setTables] = useState([]);
  const [clickedTable, setClickedTable] = useState();
  const [columns, setColumns] = React.useState([
    { title: 'Table Name', field: 'tableName' },
  ]);

  useEffect(
    () => {
      //window.gtag('config', 'UA-160225157-2', { 'page_path': '/Tables' });
    }, []
  )

  useEffect(
    () => {
      setColumns([
        {
          title: capitalizeFirstLetter(translateGui(57)),
          field: 'tableName'
        },
      ])
    }, [globalContext.globalState.selectedGuiLanguage]
  )
  useEffect(
    () => {
      if (tables.length > 0) {
        setSelectedTable(tables[0].id, tables[0].friendlyUrl, tables[0].tableName);
      }
    }, [tables]
  )


  function getTables() {
    //console.log('buradayiz');
    globalContext.dispatchMethod({ type: 'SET_MESSAGE', value: { message: '...', showButton: false } });
    getTablesHook(
      {
        url: '/admin/tables?PageNumber=1&PageSize=50',
        method: 'GET',
        postData: null,
        addTokenHeader: true,
      }
    )
  }

  const compare = (table1, table2) => {
    let comparison = -1;


    if (parseInt(table1.tableName) > parseInt(table2.tableName)) {
      comparison = 1;
    }
    return comparison;
  }

  useEffect(
    () => {
      let tableArr = [];
      //console.log(getTablesHookResponse);


      if (getTablesHookResponse.length != 0 && getTablesHookResponse) {
        getTablesHookResponse.tables.map(
          (table, index) => {
            tableArr.push({ tableName: table.title, id: table.id, friendlyUrl: table.friendlyUrl })
          }
        )

        tableArr.sort(compare);


        setTables(tableArr);
      }
      else {
        setTables(tableArr);
      }

      globalContext.dispatchMethod({ type: 'SET_MESSAGE', value: { message: '', showButton: false } });
    }, [getTablesHookResponse]
  )

  useEffect(() => {
    getTables();

    globalContext.dispatchMethod(
      {
        type: 'SET_MENU_LOCATION',
        value: {
          a: 8,
          b: 10,
        },
      }
    )
  }, [])


  useEffect(
    () => {
      getCustomerSettingsHook(
        {
          url: '/admin/customersettings',
          addTokenHeader: true,
          method: 'GET',
          postData: null,
        }
      )
    }, []
  )

  useEffect(
    () => {
      let categoryArr = [];
      //console.log(getCustomerSettingsHookResponse);
      if (getCustomerSettingsHookResponse.length != 0 && getCustomerSettingsHookResponse) {
        //setQRCodeBase64('data:image/png;base64, ' + getCustomerSettingsHookResponse.logoBase64);
        setCustomerLogoURL('http://' + getCustomerSettingsHookResponse.logoBase64);
      }
    }, [getCustomerSettingsHookResponse]
  )

  const addTable = async (newData) => {
    addTableHook(
      {
        url: '/admin/tables',
        method: 'POST',
        addTokenHeader: true,
        postData: {
          title: newData.tableName,
        },
      }
    )
  }

  useEffect(
    () => {
      //console.log(addTableHookResponse);
      if (addTableHookResponse.length != 0 && addTableHookResponse) {
        //console.log('okmis');
        getTables();
      }
    }
    , [addTableHookResponse]
  )
  const editTable = async (newData, oldData) => {
    editTableHook(
      {
        url: '/admin/tables/' + oldData.id,
        method: 'PUT',
        postData: {
          title: newData.tableName,
        },
        addTokenHeader: true,
      }
    )
  }

  useEffect(
    () => {
      //console.log(addCategoryResponse);
      if (editTableResponse.length != 0 && editTableResponse) {
        //console.log('okmis');
        getTables();
      }
    }
    , [editTableResponse]
  )

  const deleteTable = async (oldData) => {
    deleteTableHook(
      {
        url: '/admin/tables/' + oldData.id + '?softDelete=false',
        method: 'DELETE',
        postData: {
          softDelete: 'false',
        },
        addTokenHeader: true,
      }
    )
  }

  useEffect(
    () => {
      //console.log(addCategoryResponse);
      if (deleteTableResponse.length != 0 && deleteTableResponse) {
        //console.log('okmis');
        getTables();
      }
    }
    , [deleteTableResponse]
  )

  function getQRCode(tableId, friendlyUrl) {

    if (clickedTable != tableId) {
      globalContext.dispatchMethod({ type: 'SET_MESSAGE', value: { message: '...', showButton: false } });
      getQRCodeHook(
        {
          url: '/admin/tables/qr-code/' + tableId,
          method: 'GET',
          postData: null,
          addTokenHeader: true,
        }
      )

      setSelectedTableURL(friendlyUrl);
    }
  }

  useEffect(
    () => {
      if (getQRCodeResponse.length != 0 && getQRCodeResponse) {
        setQRCodeBase64('data:image/png;base64, ' + getQRCodeResponse);
        globalContext.dispatchMethod({ type: 'SET_MESSAGE', value: { message: '', showButton: false } });
      }
    }, [getQRCodeResponse]
  )

  useEffect(
    () => {
      //console.log(qrCodeBase64);
    }, [qrCodeBase64]
  )

  const setSelectedTable = (tableId, friendlyUrl, tableName) => {
    setClickedTable(tableId);
    setSelectedTableName(tableName);
    getQRCode(tableId, friendlyUrl);
  }

  const rowClick = (event, rowData, togglePanel) => {
    setSelectedTable(rowData.id, rowData.friendlyUrl, rowData.tableName);
    console.log(rowData);
  }

  const printQRCode = () => {
    //console.log('print qr code');
    //var content = document.getElementById("divcontents");
    var content = "";
    content += "<div style='display:flex; flex-direction: column; align-items: center; font-family: Roboto'>"
    content += `<img src="${customerLogoURL}">`
    content += "<span style='margin: 50px 0 20px 0;'> Please visit:  </span>"
    content += "<span style='margin: 0px 0 50px 0;'>" + selectedTableURL + " </span>"
    content += "<span style='margin-bottom: 50px; font-size:1.4rem'>" + selectedTableName + " is your table</span>";
    content += "<span style='margin-bottom: 50px; font-size: 1.8rem'> or scan the QR Code </span>";
    content += "<img style='width:250px; height:250px;' src='" + qrCodeBase64 + "' ></img>";
    content += "</div>"
    console.log(content);

    var pri = document.getElementById("ifmcontentstoprint").contentWindow;
    pri.document.open();
    pri.document.write(content);
    pri.document.close();
    pri.focus();
    pri.print();
  }

  return (
    <div className="tables">
      <MaterialTable
        options={{ paging: false, search: false }}
        title={capitalizeFirstLetter(translateGui(10))}
        columns={columns}
        data={tables}
        onRowClick={rowClick}
        editable={{
          onRowAdd: newData => new Promise((resolve, reject) => { addTable(newData); resolve() }),
          onRowUpdate: (newData, oldData) => editTable(newData, oldData),
          onRowDelete: oldData => new Promise((resolve, reject) => { deleteTable(oldData); resolve() }),
        }}
        localization={{
          header: {
            actions: capitalizeFirstLetter(translateGui(35)),
          },
          body: {
            emptyDataSourceMessage: 'No records to display',
          }
        }}
      />
      <div className="tables__QR-div">
      {capitalizeFirstLetter(translateGui(58))} {selectedTableName}:
            <div className="selected-table-url" style={{ marginTop: '10px' }}>
          {selectedTableURL}
        </div>
        <img src={qrCodeBase64} className="QR-div__img"></img>
        <div className="tables__print-button-div">
          <Button color="primary" component="span" variant="contained" onClick={printQRCode}>
          {capitalizeFirstLetter(translateGui(59))}
              </Button>
        </div>
      </div>

    </div>
  );
}
export default Tables;
